(function(root){
  function buildItems(variants,size,colors,groups){
    if(!size) throw new Error('Bitte wähle zuerst deine Größe.');
    if(![1,3].includes(groups)||colors.length!==groups) throw new Error('Bitte vervollständige deine Set-Auswahl.');
    const result=new Map();
    for(const color of colors){
      const variant=variants.find(v=>v.options[0]===color&&v.options[1]===size);
      if(!variant||!variant.available) throw new Error('Diese Farbe ist in deiner Größe aktuell nicht verfügbar. Bitte wähle eine andere Farbe.');
      result.set(variant.id,(result.get(variant.id)||0)+1);
    }
    return [...result].map(([id,quantity])=>({id,quantity}));
  }
  function packProperties(properties={}){
    const result={...properties};
    if(result.Set==='6 + 3 Paar gratis')delete result.Set;
    if(['1 kostenloses Wäschenetz zum Vorteilsset','Teil des Vorteilssets'].includes(result.Beigabe))delete result.Beigabe;
    result.Packungsinhalt='3 Paar pro Einheit';
    result.Beigabenaktion='Ab 9 Paar dieses Modells: 1 Wäschenetz pro Bestellung.';
    return result;
  }
  function packSummary(items,productId){
    const units=items.filter(item=>String(item.product_id)===String(productId)).reduce((n,item)=>n+Number(item.quantity),0);
    return {pairs:units*3,giftEligible:units>=3};
  }
  const api={buildItems,packProperties,packSummary};
  if(typeof module!=='undefined'&&module.exports)module.exports=api;
  root.LoveosCart=api;
})(typeof window!=='undefined'?window:globalThis);
